import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Paper } from "@material-ui/core";
import TableGeneric from "../../../compartidos/abms/TableGeneric";

import IconEstado from "../../../autorizaciones/UI/IconEstado";
import ToolbarXLSPDF from "../../../compartidos/ToolbarXLSPDF";
import moment from "moment";
import { MENU_TIPO_INGRESO_RECLAMO } from "../../../../utils/constants";
import { generarExcelReclamosEnviadosEfector } from "../../../../actions/reclamos/reclamosEfectorActions";
import { generarExcelReclamosEnviadosAfiliados, setSolicitudReclamo } from "../../../../actions/reclamos/reclamosActions";
import { generarExcelReclamosEnviadosExternos } from "../../../../actions/reclamos/reclamosExternosActions";
import InfoHistorialIcon from "../../../autorizaciones/UI/InfoHistorialIcon";
import { ModalTrackingReclamos } from "../ModalTrackingReclamos";
import { ModalTrackingReclamoExterno } from "../ModalIngresoReclamosExternos/StepperIngreso/ModalTrackingReclamoExterno";
import { ModalDetalleReclamos } from "../ModalGestionReclamos/ModalDetalleReclamos";
import { IconInfo } from "../IconInfo";
import { ModalDetalleReclamoExterno } from "../ModalIngresoReclamosExternos/GestionReclamoExterno/ModalDetalleReclamoExterno";

export const ListadoReclamosEnviados = (props) => {
  const { tipoIngreso, estado, fechaInicio, fechaFin, idAfiliado, idEfector, cuit, destino, subDestino } = props;
  const { reclamos } = useSelector((state) => state.reclamos);
  const dispatch = useDispatch();
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [idClave, setIdClave] = useState(false);
  const [descripcion, setDescripcion] = useState(false);
  const [openModalInfoExternos, setOpenModalInfoExternos] = useState(false);
  const [idClaveExternos, setIdClaveExternos] = useState(false);
  const [descripcionExternos, setDescripcionExternos] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] =
    useState(false);
  const [openModalHistorialCambiosExternos, setOpenModalHistorialCambiosExternos] =
    useState(false);

  return (
    <React.Fragment>
      {openModalInfo && (
        <ModalTrackingReclamos
          open={openModalInfo}
          onClose={() => setOpenModalInfo(false)}
          idClave={idClave}
          descripcion={descripcion}
        />
      )}
      {openModalInfoExternos && (
        <ModalTrackingReclamoExterno
          open={openModalInfoExternos}
          onClose={() => setOpenModalInfoExternos(false)}
          idClave={idClaveExternos}
          descripcion={descripcionExternos}
        />
      )}
      {openModalHistorialCambios && (
        <ModalDetalleReclamos
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          disabled={true}

        />
      )}
      {openModalHistorialCambiosExternos && (
        <ModalDetalleReclamoExterno
          open={openModalHistorialCambiosExternos}
          closeModalHandler={() => {
            setOpenModalHistorialCambiosExternos(false);
          }}
          disabled={true}

        />
      )}
      {tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.AFILIADO &&
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12} md={11} style={{ paddingLeft: 0, marginTop: 20 }}>
            <ToolbarXLSPDF
              handleExportExcel={() => dispatch(generarExcelReclamosEnviadosAfiliados(estado, fechaInicio, fechaFin, idAfiliado, destino, subDestino))}
            />
          </Grid>

          <Grid item xs={12} md={11} style={{ paddingLeft: 0, marginTop: 20 }}>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              component={Paper}
              spacing={2}
            >

              <Grid item xs={12}>
                <TableGeneric
                  data={reclamos}
                  columns={[
                    {
                      label: "",
                      id: "",
                      sort: false,
                      customBody: (item) => (
                        <InfoHistorialIcon
                          onClick={() => {
                            setOpenModalInfo(true);
                            setIdClave(item?.id);
                            setDescripcion(`${item?.descripcion}`);
                          }}
                        />
                      ),
                    },
                    {
                      label: "Semáforo",
                      customBody: (item) => (
                        <IconEstado
                          useColorTable={true}
                          texto={item?.letraUrgente}
                          backgroundColor={item?.colorUrgente}
                          descripcion={item?.descripcionUrgente}
                        />
                      ),
                    },
                    {
                      label: "Estado",
                      customBody: (item) => (
                        <IconEstado
                          useColorTable={true}
                          texto={item?.letraEstado}
                          backgroundColor={item?.color}
                          descripcion={item?.descripcionUrgente}
                        />
                      ),
                    },
                    {
                      label: "Nro",
                      id: "id",
                      sort: true,
                    },
                    {
                      label: "Nro Beneficiaria/o",
                      id: "carnet",
                      sort: true,
                    },
                    {
                      label: "Apellido y Nombre",
                      id: "descripcionAfiliado",
                      sort: true,
                    },
                    {
                      label: "Fecha Carga",
                      id: "fechaCarga",
                      customBody: (item) =>
                        moment(item.fechaCarga).format("DD/MM/YYYY"),
                    },
                    {
                      label: "Tipo",
                      id: "descripcionTipoReclamo",
                      sort: true,
                    },
                    {
                      label: "Origen",
                      id: "descripcionTipoOrigen",
                      sort: true,
                    },

                    {
                      label: "Categoría",
                      id: "descripcionCategoriaReclamo",
                      sort: true,
                    },
                    {
                      label: "Área derivado",
                      id: "derivado",
                      sort: true,
                    },
                    {
                      label: "Sub Área",
                      id: "subDerivado",
                      sort: true,
                    },
                    {
                      label: "Origen del error",
                      id: "descripcionTipoErrorReclamo",
                      sort: true,
                    },
                    {
                      label: "Fecha Vencimiento",
                      id: "fechaCarga",
                      customBody: (item) =>
                        moment(item.fechaVencimiento).format("DD/MM/YYYY"),
                    },
                    {
                      label: "Información",
                      id: "",
                      sort: false,
                      customBody: (item) => (
                        <IconInfo
                          onClick={() => {
                            dispatch(setSolicitudReclamo(item));
                            setOpenModalHistorialCambios(true);
                          }}
                        />
                      ),
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
      {tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.PRESTADOR &&
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12} md={11} style={{ paddingLeft: 0, marginTop: 20 }}>
            <ToolbarXLSPDF
              handleExportExcel={() => dispatch(generarExcelReclamosEnviadosEfector(estado, fechaInicio, fechaFin, idEfector))}
            />
          </Grid>
          <Grid item xs={12} md={11} style={{ paddingLeft: 0, marginTop: 20 }}>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              component={Paper}
              spacing={2}
            >

              <Grid item xs={12}>
                <TableGeneric
                  data={reclamos}
                  columns={[
                    {
                      label: "Semáforo",
                      customBody: (item) => (
                        <IconEstado
                          useColorTable={true}
                          texto={item?.letraUrgente}
                          backgroundColor={item?.colorUrgente}
                          descripcion={item?.descripcionUrgente}
                        />
                      ),
                    },
                    {
                      label: "Estado",
                      customBody: (item) => (
                        <IconEstado
                          useColorTable={true}
                          texto={item?.letraEstado}
                          backgroundColor={item?.color}
                          descripcion={item?.descripcionUrgente}
                        />
                      ),
                    },
                    {
                      label: "Nro",
                      id: "id",
                      sort: true,
                    },
                    {
                      label: "Id efector",
                      id: "idEfectorFacturacion",
                      sort: true,
                    },
                    {
                      label: "Efector",
                      id: "descripcionEfector",
                      sort: true,
                    },
                    {
                      label: "Fecha Carga",
                      id: "fechaCarga",
                      customBody: (item) =>
                        moment(item.fechaCarga).format("DD/MM/YYYY"),
                    },
                    {
                      label: "Tipo",
                      id: "descripcionTipoReclamo",
                      sort: true,
                    },
                    {
                      label: "Origen",
                      id: "descripcionTipoOrigen",
                      sort: true,
                    },

                    {
                      label: "Categoría",
                      id: "descripcionCategoriaReclamo",
                      sort: true,
                    },
                    {
                      label: "Área derivado",
                      id: "derivado",
                      sort: true,
                    },
                    {
                      label: "Sub Área",
                      id: "subDerivado",
                      sort: true,
                    },
                    {
                      label: "Origen del error",
                      id: "descripcionTipoErrorReclamo",
                      sort: true,
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
      {tipoIngreso === MENU_TIPO_INGRESO_RECLAMO.EXTERNOS &&
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12} md={11} style={{ paddingLeft: 0, marginTop: 20 }}>
            <ToolbarXLSPDF
              handleExportExcel={() => dispatch(generarExcelReclamosEnviadosExternos(estado, fechaInicio, fechaFin, cuit, destino, subDestino))}
            />
          </Grid>

          <Grid item xs={12} md={11} style={{ paddingLeft: 0, marginTop: 20 }}>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              component={Paper}
              spacing={2}
            >

              <Grid item xs={12}>
                <TableGeneric
                  data={reclamos}
                  columns={[
                    {
                      label: "",
                      id: "",
                      sort: false,
                      customBody: (item) => (
                        <InfoHistorialIcon
                          onClick={() => {
                            setOpenModalInfoExternos(true);
                            setIdClaveExternos(item?.id);
                            setDescripcionExternos(`${item?.descripcion}`);
                          }}
                        />
                      ),
                    },
                    {
                      label: "Semáforo",
                      customBody: (item) => (
                        <IconEstado
                          useColorTable={true}
                          texto={item?.letraUrgente}
                          backgroundColor={item?.colorUrgente}
                          descripcion={item?.descripcionUrgente}
                        />
                      ),
                    },
                    {
                      label: "Estado",
                      customBody: (item) => (
                        <IconEstado
                          useColorTable={true}
                          texto={item?.letraEstado}
                          backgroundColor={item?.color}
                          descripcion={item?.descripcionUrgente}
                        />
                      ),
                    },
                    {
                      label: "Nro",
                      id: "id",
                      sort: true,
                    },
                    {
                      label: "CUIL / CUIT",
                      id: "cuit",
                      sort: true,
                    },
                    {
                      label: "NOMBRE / RAZON SOCIAL",
                      id: "nombre",
                      sort: true,
                    },
                    {
                      label: "Fecha Carga",
                      id: "fechaCarga",
                      customBody: (item) =>
                        moment(item.fechaCarga).format("DD/MM/YYYY"),
                    },
                    {
                      label: "Tipo",
                      id: "descripcionTipoReclamo",
                      sort: true,
                    },
                    {
                      label: "Origen",
                      id: "descripcionTipoOrigen",
                      sort: true,
                    },

                    {
                      label: "Categoría",
                      id: "descripcionCategoriaReclamo",
                      sort: true,
                    },
                    {
                      label: "Área derivado",
                      id: "derivado",
                      sort: true,
                    },
                    {
                      label: "Sub Area",
                      id: "subDerivado",
                      sort: true,
                    },
                    {
                      label: "Origen del error",
                      id: "descripcionTipoErrorReclamo",
                      sort: true,
                    },
                    {
                      label: "Fecha Vencimiento",
                      id: "fechaCarga",
                      customBody: (item) =>
                        moment(item.fechaVencimiento).format("DD/MM/YYYY"),
                    },
                    {
                      label: "Información",
                      id: "",
                      sort: false,
                      customBody: (item) => (
                        <IconInfo
                          onClick={() => {
                            dispatch(setSolicitudReclamo(item));
                            setOpenModalHistorialCambiosExternos(true);
                          }}
                        />
                      ),
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
    </React.Fragment>
  )
}
